module.exports = __webpack_public_path__ + "static/media/continuous-planning.ff451928.png";